<script>
import { watch, ref } from 'vue';
import pdfMake from "pdfmake/build/pdfmake";
import { pdfFileName, pdfDate, openPdf } from '@/utils/pdfFile';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import BillingServices from '@/services/BillingServices';
import moment from 'moment';
export default {
  props: {
    billing_id: Number,
    salesman_id: Number,
    salesman_name: String,
    billing_date: String,
    counter: Number
  },
  setup(props) {
    const root = ref(null);
    const pdfData = ref([]);
    const documentDefinition = ref({});
    const body = ref([]);
    const totalBalance = ref(0);
    const totalCurrentBill = ref(0);
    const totalPreviousBalance = ref(0);
    const totalAmount = ref(0);
    const dayName = ref('');
    const parseNumber = (value) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    };
    const formatNumber = (value) => {
      const parsed = parseNumber(value);
      if (Number.isInteger(parsed)) {
        return parsed.toString();
      }
      return parsed.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    };
    const buildTableBody = async () => {
      const columns = [
        'Sr#',
        'Shop Name',
        'Address',
        'Last Bill Date & Amount',
        'Last Recovery Date & Amount',
        'Current Balance',
        'Received',
        'Remarks',
      ];
      console.log('hey man this is it');
      console.log(columns);
      const body = [];
      await body.push(columns);
      console.log('after body push columns');

      return columns;
    };

    const loadPdf = async () => {
      await BillingServices.getMainPdfContent(
        props.salesman_id,
        props.billing_id
      )
        .then((response) => {
          pdfData.value = response.data.data;
        })
        .then(() => {
          let columns = [];
          body.value = [];
          totalBalance.value = 0;
          totalCurrentBill.value = 0;
          totalPreviousBalance.value = 0;
          totalAmount.value = 0;
          columns = [
            {
              text: 'Sr#',
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 6, 0, 0],
            },
            {
              text: 'Shop Name',
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 6, 0, 0],
            },
            {
              text: 'Address',
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 6, 0, 0],
            },
            {
              text: 'Previous Balance',
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 0, 0, 0],
            },
            { text: 'Current Bill', style: 'defaultFont', alignment: 'center' },
            {
              text: 'Amount',
              style: 'defaultFont',
              alignment: 'center'
            },
            {
              text: 'Total',
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 6, 0, 0],
            },
            {
              text: 'Cash Received',
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 0, 0, 0],
            },
            {
              text: 'Shopkeeper Sign',
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 0, 0, 0],
            },
          ];
          body.value.push(columns);

          let i = 1;
          pdfData.value.forEach(function (row) {

            const dataRow = [];
            const seriol_no = {
              text: i.toString(),
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 6, 0, 0],
            };
            dataRow.push(seriol_no);
            const shop_name = {
              style: 'defaultFont',
              alignment: 'center',
            };

            if (row['shop_name'] != '') {
              //shop_name['text']="malik asgher medical store";
              shop_name['text'] = row['shop_name'].toString();
            } else {
              shop_name['text'] = '';
            }
            dataRow.push(shop_name);

            const address = {
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 5, 0, 0],
            };

            console.log(i);
            if (row['address'] != '') {
              //address['text']="adil";
              address['text'] = row['address'].toString();
            } else {
              address['text'] = '';
            }

            dataRow.push(address);

            const previousBalanceValue = parseNumber(row['previousBalance']);
            totalPreviousBalance.value += previousBalanceValue;
            const prev_balance = {
              text: formatNumber(previousBalanceValue),
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 5, 0, 0],
            };
            dataRow.push(prev_balance);

            const currentBillValue = parseNumber(row['currentBill']);
            totalCurrentBill.value += currentBillValue;
            const current_bill = {
              text: formatNumber(currentBillValue),
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 5, 0, 0],
            };
            dataRow.push(current_bill);

            const amountValue = parseNumber(row['amount']);
            totalAmount.value += amountValue;
            const amount = {
              text: formatNumber(amountValue),
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 6, 0, 0],
            };
            dataRow.push(amount);

            const totalValue = parseNumber(row['total']);
            totalBalance.value += totalValue;
            const total = {
              text: formatNumber(totalValue),
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 6, 0, 0],
            };
            dataRow.push(total);

            const empty1 = {
              text: '-',
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 6, 0, 0],
            };
            const empty2 = {
              text: '-',
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 6, 0, 0],
            };
            dataRow.push(empty1);
            dataRow.push(empty2);
            body.value.push(dataRow);

            //}
            i++;
          });
        })
        .then(() => {
          const totalsRow = [
            {
              text: '',
              style: 'defaultFont',
              margin: [0, 5, 0, 0],
              border: [false, false, false, false],
            },
            {
              text: 'Totals',
              style: 'defaultFont',
              alignment: 'right',
              margin: [0, 5, 0, 0],
              border: [false, false, false, false],
            },
            {
              text: '',
              style: 'defaultFont',
              margin: [0, 5, 0, 0],
              border: [false, false, false, false],
            },
            {
              text: formatNumber(totalPreviousBalance.value),
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 5, 0, 0],
              border: [false, false, false, false],
            },
            {
              text: formatNumber(totalCurrentBill.value),
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 5, 0, 0],
              border: [false, false, false, false],
            },
            {
              text: formatNumber(totalAmount.value),
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 5, 0, 0],
              border: [false, false, false, false],
            },
            {
              text: formatNumber(totalBalance.value),
              style: 'defaultFont',
              alignment: 'center',
              margin: [0, 5, 0, 0],
              border: [false, false, false, false],
            },
            {
              text: '',
              style: 'defaultFont',
              margin: [0, 5, 0, 0],
              border: [false, false, false, false],
            },
            {
              text: '',
              style: 'defaultFont',
              margin: [0, 5, 0, 0],
              border: [false, false, false, false],
            },
          ];
          body.value.push(totalsRow);
        })
        .then(() => {
          const days = [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
          ];
          const d = new Date(props.billing_date);
          dayName.value = days[d.getDay()];

          documentDefinition.value = {
            content: [
              {
                columns: [
                  {
                    width: '50%',
                    text:
                      'DATE:' + moment(props.billing_date).format('DD/MM/YY'),
                    style: ['defaultFont', 'mb10'],
                  },

                  {
                    width: '51%',
                    text: 'Day:' + dayName.value,
                    style: ['defaultFont', 'textRight', 'mb10'],
                  },
                ],
              },
              {
                columns: [
                  {
                    width: '50%',
                    text: 'Invoice #: ' + props.billing_id,
                    style: ['defaultFont', 'mb2'],
                  },
                  {
                    width: '50%',
                    text: '',
                  },
                ],
              },
              {
                columns: [
                  {
                    width: '100%',
                    text:
                      'SALESMAN: ' +
                      props.salesman_name +
                      ' (' +
                      props.salesman_id +
                      ')',
                    style: ['defaultFont', 'mb2'],
                  },
                ],
              },
              {
                table: {
                  headerRows: 1,
                  //widths: ['auto', 'auto', 'auto', 60, 60, 60, 'auto', 'auto'],

                  body: body.value,
                },
              },
            ],
            styles: {
              defaultFont: {
                fontSize: 11,
                bold: true,
              },
              textRight: {
                alignment: 'right',
              },
              textCenter: {
                alignment: 'center',
              },
              mt2: {
                margin: [0, 2, 0, 0],
              },
              mb2: {
                margin: [0, 0, 0, 2],
              },
              mb10: {
                margin: [0, 0, 0, 10],
              },
              mCustom: {
                margin: [33, 2, 0, 0],
              },
            },
          };
        })
        .then(() => {
          pdfMake.vfs = pdfFonts;
          openPdf(pdfMake, documentDefinition.value, pdfFileName(['Billing', props.billing_id, props.salesman_name], pdfDate(props.billing_date)));
        });
    };
    watch(
      () => props.counter,
      (currentValue, oldValue) => {
        if (currentValue != oldValue && currentValue != '') {
          loadPdf();
        }
      }
    );

    return {
      root,
      pdfData,
      buildTableBody,
      documentDefinition,
      body,
      totalBalance,
      totalCurrentBill,
      totalPreviousBalance,
      totalAmount,
      dayName,
    };
  },
};
</script>
